import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="page-wrapper" style={{paddingBottom:60}}>
      {/* Hero */}
      <div style={{background:'linear-gradient(135deg,#0D1421 0%,#0a2a4a 50%,#0D1421 100%)',padding:'80px 20px',textAlign:'center',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',inset:0,backgroundImage:'radial-gradient(ellipse at 30% 50%, rgba(0,212,255,0.1) 0%, transparent 60%)'}} />
        <div style={{position:'relative'}}>
          <div style={{fontSize:48,marginBottom:16}}>⚡</div>
          <h1 style={{fontSize:40,fontWeight:800,marginBottom:16}}>من نحن</h1>
          <p style={{color:'var(--color-text-muted)',fontSize:18,maxWidth:600,margin:'0 auto',lineHeight:1.8}}>
            SPORTIX هي منصة التوظيف والخدمات الرياضية الرائدة في المنطقة العربية
          </p>
        </div>
      </div>

      <div className="container" style={{maxWidth:900,paddingTop:48}}>

        {/* Mission */}
        <div className="card" style={{padding:40,marginBottom:24,textAlign:'center'}}>
          <div style={{fontSize:40,marginBottom:16}}>🎯</div>
          <h2 style={{fontSize:24,fontWeight:700,marginBottom:16}}>رسالتنا</h2>
          <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:16,maxWidth:700,margin:'0 auto'}}>
            نسعى لربط أفضل المحترفين الرياضيين بأبرز الأندية والمؤسسات الرياضية في المنطقة العربية، وتوفير منصة متكاملة تخدم جميع احتياجات القطاع الرياضي من توظيف وخدمات متخصصة.
          </p>
        </div>

        {/* Stats */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:16,marginBottom:24}}>
          {[
            {n:'500+',l:'وظيفة منشورة',i:'💼'},
            {n:'200+',l:'مؤسسة رياضية',i:'🏆'},
            {n:'1000+',l:'محترف رياضي',i:'👥'},
            {n:'10+',l:'دول عربية',i:'🌍'},
          ].map((s,i)=>(
            <div key={i} className="card" style={{padding:24,textAlign:'center'}}>
              <div style={{fontSize:32,marginBottom:8}}>{s.i}</div>
              <div style={{fontSize:28,fontWeight:800,color:'var(--color-primary)'}}>{s.n}</div>
              <div style={{fontSize:13,color:'var(--color-text-muted)',marginTop:4}}>{s.l}</div>
            </div>
          ))}
        </div>

        {/* Story */}
        <div className="card" style={{padding:40,marginBottom:24}}>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:20,display:'flex',alignItems:'center',gap:10}}>📖 قصتنا</h2>
          <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:15,marginBottom:16}}>
            بدأت SPORTIX من رؤية بسيطة: القطاع الرياضي في المنطقة العربية يعاني من فجوة كبيرة بين المحترفين الرياضيين الموهوبين والمؤسسات التي تبحث عنهم. كان الأمر يستغرق أشهراً للعثور على المدرب المناسب أو الطبيب الرياضي أو المحلل الصحيح.
          </p>
          <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:15,marginBottom:16}}>
            قررنا تغيير ذلك. أسسنا SPORTIX لتكون المنصة المتخصصة الأولى في المنطقة التي تجمع تحت سقف واحد كل ما يحتاجه القطاع الرياضي: وظائف، خدمات، محترفون، ومؤسسات.
          </p>
          <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:15}}>
            اليوم، نفخر بخدمة مئات المؤسسات الرياضية وآلاف المحترفين عبر المنطقة العربية، ونواصل رحلتنا نحو تطوير القطاع الرياضي وتمكين أبطاله.
          </p>
        </div>

        {/* Values */}
        <div className="card" style={{padding:40,marginBottom:24}}>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:24,display:'flex',alignItems:'center',gap:10}}>💎 قيمنا</h2>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:20}}>
            {[
              {i:'🎯',t:'الاحترافية',d:'نلتزم بأعلى معايير الجودة في كل خدمة نقدمها'},
              {i:'🤝',t:'الثقة والشفافية',d:'نبني علاقات مبنية على الصدق والوضوح مع جميع أطراف المنصة'},
              {i:'🚀',t:'الابتكار',d:'نسعى دائماً لتطوير حلول تقنية تواكب احتياجات القطاع الرياضي'},
              {i:'🌍',t:'الشمولية',d:'نخدم جميع أبطال الرياضة بغض النظر عن تخصصاتهم أو مواقعهم'},
            ].map((v,i)=>(
              <div key={i} style={{display:'flex',gap:16,padding:20,background:'rgba(0,212,255,0.05)',borderRadius:12,border:'1px solid rgba(0,212,255,0.1)'}}>
                <div style={{fontSize:28,flexShrink:0}}>{v.i}</div>
                <div>
                  <div style={{fontWeight:700,marginBottom:6}}>{v.t}</div>
                  <div style={{color:'var(--color-text-muted)',fontSize:13,lineHeight:1.7}}>{v.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div style={{textAlign:'center',padding:40,background:'linear-gradient(135deg,rgba(0,212,255,0.1),rgba(255,107,53,0.05))',borderRadius:20,border:'1px solid rgba(0,212,255,0.2)'}}>
          <h3 style={{fontSize:22,fontWeight:700,marginBottom:12}}>انضم إلى مجتمع SPORTIX</h3>
          <p style={{color:'var(--color-text-muted)',marginBottom:24}}>سواء كنت محترفاً رياضياً أو مؤسسة، ابدأ رحلتك معنا اليوم</p>
          <div style={{display:'flex',gap:12,justifyContent:'center'}}>
            <Link to="/auth/register" className="btn btn-primary" style={{padding:'12px 28px'}}>انضم مجاناً</Link>
            <Link to="/jobs" className="btn btn-ghost" style={{padding:'12px 28px'}}>استعرض الوظائف</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
